'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/index.js
// module id = 622
// module chunks = 1